export default "__VITE_ASSET__19ffdc4d__"